// navigate.js - direct window.location navigation

// const navigate = url => {
//   const { protocol, hostname } = window.location

//   console.log("Navigate executed with url: " + url)

//   if (window.Backbone?.Router)
//     window.Backbone.history.navigate(url, {trigger: true})
//   else
//     window.location.assign(url)
// }

const navigate = url => {
  const { protocol, hostname } = window.location
  const isRelative = url.split('.').length < 2

  isRelative
    ? window.location.assign(`${protocol}//${hostname}${url}`)
    : window.location.assign(url)
}

export default navigate